module.exports = __webpack_public_path__ + "static/img/yx2.f2f806c6.png";